import { Component, OnInit } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})

export class ReportsComponent implements OnInit {

  constructor(private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private productFindService: NgbModal,) { }

  ngOnInit() {
  }


  fnRedirectReport(type) {
    try {
         
        this.router.navigate(['/Reports/'+type]);  
      
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }    

  }

  
  
  fnRedirectReportDirect(type) {
    try {
         
        this.router.navigate(['/'+type]);  
      
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }    

  }

  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }

}
